module.exports = __webpack_public_path__ + "static/img/xing.8f7aae60.svg";